exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".igx-navbar{position:relative;flex-flow:row nowrap;justify-content:space-between;width:100%;height:56px;padding:0 1em;background:#0375be;color:#fff;box-shadow:0 2px 4px -1px rgba(0,0,0,.26),0 4px 5px 0 rgba(0,0,0,.12),0 1px 10px 0 rgba(0,0,0,.08);z-index:4}.igx-navbar,.igx-navbar__left,.igx-navbar__right{display:flex;align-items:center}.igx-navbar__left *+*,.igx-navbar__right *+*{margin-left:16px}.igx-navbar__title{margin:0;font-size:1.125em;line-height:1.125em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true}!./node_modules/sass-loader/lib/loader.js!./src/navbar/navbar.component.scss
// module id = 120
// module chunks = 0 1